import { Box, Button, Spinner, useToggle } from '@factorialco/deprecated-design-system'

import Popover from 'modules/core/components/Popover'
import PopoverContent from 'modules/core/components/Popover/Content'
import type { Option } from 'modules/core/components/Popover/Content'
import i18n from 'modules/core/lib/i18n'

interface Props {
  setShowPreview: (showPreview: boolean) => void
  showDeleteOnly?: boolean
  options: Option[]
  loading?: boolean
}

const Actions = ({ options, showDeleteOnly, setShowPreview, loading = false }: Props) => {
  const [open, toggle] = useToggle(false)

  const deleteOption = options.find((option) => option.title === i18n.t('common.delete'))

  if (loading) return <Spinner size="s24" />
  return (
    <Box gap="s8" flexDirection="row">
      {!showDeleteOnly && (
        <Popover
          attachment="top right"
          open={open}
          targetAttachment="bottom center"
          toggle={toggle}
        >
          <Button type="secondary" onClick={toggle(true)} iconName="ellipsis" />
          <PopoverContent onClose={toggle(false)} options={options} />
        </Popover>
      )}
      {deleteOption && showDeleteOnly && (
        <Button onClick={deleteOption.onClick} type="secondary" iconName="delete" />
      )}
      <Button onClick={() => setShowPreview(true)} type="secondary" iconName="arrow-right" />
    </Box>
  )
}

export default Actions
